var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityOn = function SvgSecurityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#security-on_svg__a)",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M3.876 3.008 3 3.118v10.557a7 7 0 0 0 3.29 5.935l5.18 3.238.53.331.53-.331 5.18-3.238A7 7 0 0 0 21 13.676V3.117l-.876-.11-8-1L12 1.993l-.124.016z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#security-on_svg__b)",
    d: "M20 4v9.675a6 6 0 0 1-2.82 5.087L12 22V3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 11.438 10.685 13 15 9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-on_svg__a",
    x1: 11.814,
    x2: 11.814,
    y1: 4.142,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-on_svg__b",
    x1: 11.814,
    x2: 11.814,
    y1: 4.142,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18663A"
  })))));
};
export default SvgSecurityOn;